<template>
  <div class="text-left wrapper-inside">
    <div class="bg-card">
      <h2>{{ $t('pages.hr.delegating-user-for-offer', 'You are delegating a user for this offer') }}</h2>
      <OfferInfoCard :current-offer="offer" />
    </div>
    <div class="bg-card">
      <h2>{{ $t('pages.hr.select-user', 'Select the user') }}</h2>
      <Users />
    </div>
  </div>
</template>

<script>
import OfferInfoCard from '@/components/jobs/public/offerInfoCard';
import Users from '@/views/jobs/admin/Users';

export default {
  components: {
    OfferInfoCard,
    Users
  },
  data() {
    return {
      offerId: null,
      offer: null
    }
  },
  mounted() {
    this.offerId = this.$route.params.id;
    this.getOffer();
  },
  methods: {
    getOffer() {
      this.axios.get('/offer/one/' + this.offerId)
        .then( response => {
          this.offer = response.data;
        })
        .catch();
    }
  }
}
</script>

<style>

</style>
